import type { ReactNode } from 'react';

export type AppToastContent = string | ReactNode;

type AppToastListener = (content: AppToastContent) => void;

let appToastListener: AppToastListener | null = null;

export function setAppToastListener(listener: AppToastListener | null) {
  appToastListener = listener;
}

export function showAppToast(content: AppToastContent) {
  appToastListener?.(content);
}
